// services/RoleService.js
import api from "../utils/axios";
import { ENDPOINTS } from "../utils/endpoints";

// LIST (paginated)
export function getRoles(params = {}) {
    return api.get(ENDPOINTS.ROLES.BASE, { params });
}

// GET ONE (avec ses permissions)
export function getRoleById(id) {
    return api.get(ENDPOINTS.ROLES.BY_ID(id));
}

// CREATE
export function createRole(payload) {
    return api.post(ENDPOINTS.ROLES.BASE, payload);
}

// UPDATE
export function updateRole(id, payload) {
    return api.patch(ENDPOINTS.ROLES.BY_ID(id), payload);
}

// DELETE (refusé si des utilisateurs sont assignés à ce rôle)
export function deleteRole(id) {
    return api.delete(ENDPOINTS.ROLES.BY_ID(id));
}

// RESTORE
export function restoreRole(id) {
    return api.post(`${ENDPOINTS.ROLES.BY_ID(id)}/restore`);
}

// REMPLACER L'ENSEMBLE DES PERMISSIONS D'UN RÔLE
export function setRolePermissions(id, permissionIds) {
    return api.put(`${ENDPOINTS.ROLES.BY_ID(id)}/permissions`, {
        permission_ids: permissionIds,
    });
}
